import { render, staticRenderFns } from "./DriverBlackList.vue?vue&type=template&id=c680b828&scoped=true"
import script from "./DriverBlackList.vue?vue&type=script&lang=js"
export * from "./DriverBlackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c680b828",
  null
  
)

export default component.exports